<template>
  <div>
    <!-- Navigation-->
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top nav-cs-h border-bottom align-items-start align-items-sm-center justify-content-between" id="mainNav" style=" display:-webkit-flex;display: flex;">
        <div class="row justify-content-between align-items-center">

<div class="col-md-2 col-6 navbar_left" style="float:left;">
  <div class="mr-menu">
      <div class="menu-icon-link-wrapper">
        <div class="menu-btn-icon">
        <a id="mobile_toggle_btn" class="navbar-toggler navbar-toggler-left"  type="button"
          data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
          aria-label="Toggle navigation" style="display:none; order:1;">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.3999 4.0002C2.3999 3.78802 2.48419 3.58454 2.63422 3.43451C2.78425 3.28448 2.98773 3.2002 3.1999 3.2002H12.7999C13.0121 3.2002 13.2156 3.28448 13.3656 3.43451C13.5156 3.58454 13.5999 3.78802 13.5999 4.0002C13.5999 4.21237 13.5156 4.41585 13.3656 4.56588C13.2156 4.71591 13.0121 4.8002 12.7999 4.8002H3.1999C2.98773 4.8002 2.78425 4.71591 2.63422 4.56588C2.48419 4.41585 2.3999 4.21237 2.3999 4.0002ZM2.3999 8.0002C2.3999 7.78802 2.48419 7.58454 2.63422 7.43451C2.78425 7.28448 2.98773 7.2002 3.1999 7.2002H12.7999C13.0121 7.2002 13.2156 7.28448 13.3656 7.43451C13.5156 7.58454 13.5999 7.78802 13.5999 8.0002C13.5999 8.21237 13.5156 8.41585 13.3656 8.56588C13.2156 8.71591 13.0121 8.8002 12.7999 8.8002H3.1999C2.98773 8.8002 2.78425 8.71591 2.63422 8.56588C2.48419 8.41585 2.3999 8.21237 2.3999 8.0002ZM2.3999 12.0002C2.3999 11.788 2.48419 11.5845 2.63422 11.4345C2.78425 11.2845 2.98773 11.2002 3.1999 11.2002H7.9999C8.21208 11.2002 8.41556 11.2845 8.56559 11.4345C8.71562 11.5845 8.7999 11.788 8.7999 12.0002C8.7999 12.2124 8.71562 12.4159 8.56559 12.5659C8.41556 12.7159 8.21208 12.8002 7.9999 12.8002H3.1999C2.98773 12.8002 2.78425 12.7159 2.63422 12.5659C2.48419 12.4159 2.3999 12.2124 2.3999 12.0002Z" fill="#9C9BAE"/>
          </svg>
        </a>  
        <button id="tab_toggle_btn" class="navbar-toggler navbar-toggler-right" style="background-color:#48a6a6; display:inline-block;" type="button"
        data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
        aria-label="Toggle navigation" >
        <span class="navbar-toggler-icon"></span>
      </button>
      </div>
        <router-link class="navbar-brand text-center" to="/"  id="main_row_navbar" style="order:2;">
          <!-- <font-awesome-icon icon="book" /> -->
      
          <div id="main_row" class="row ml-2">
            <div>
              <span class="main_span" style="font-size:22px;font-weight:600 !important;margin-right:5px;color:#000000;">LinenTech</span>
            </div>
            <div id="cpanel_div">
              <span
                style="font-size:7px;font-weight:700 !important;color:white;background-color:#48a6a6;padding:4px 6px;border-radius:4px">Admin Panel</span>
            </div>
          </div>
        </router-link>
      </div>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <sidebar />
        <navbar />
      </div>
        </div>

</div>    
          <NavbarHeading />

          <div class="col-md-3 col-2 text-right swicth_dashboard_btn-col">
            <div class="ui buttons big swicth_dashboard_btn" id="multiproduct-tabs"  v-for="availableProduct in userAvaliableProducts" :key="(availableProduct.slug)" v-if="$route.path=='/demo-leads' || ($route.path === '/demo-leads' && $route.query.page) || $route.fullPath.includes('/task') || $route.path=='/categories' || $route.path=='/posts' || $route.path=='/posts/new-post' || $route.path=='/posts/unpublished' || $route.path=='/case-study' || $route.path=='/case-study/create' || $route.path=='/user-guide' || $route.path=='/user-guide/create' || $route.path=='/event' || $route.path=='/event/create' || $route.path=='/brochure' || $route.path=='/brochure/create' || $route.path=='/webinar' || $route.path=='/webinar/create'">
                  <button id="swicth_dashboard_btn_linentech"
                  v-if="availableProduct.slug == 'linentech' && availableProduct.status == 1"
                    class="ui button toggle "
                    :class="[softwareSelection == 'linentech' ? 'isactive_linentech' : '']"
                    @click="SwitchProduct(availableProduct.slug,availableProduct.id)"
                  >{{availableProduct.name}}
                  </button>
                  <button
                    class="ui button toggle"
                    :class="[softwareSelection == 'staffer'? 'isactive_thestaffer' : '']"
                    v-if="availableProduct.slug == 'staffer' && availableProduct.status == 1"
                    @click="SwitchProduct(availableProduct.slug,availableProduct.id)" id="swicth_dashboard_btn_staffer"
                    
                  >{{availableProduct.name}}
                  
                  </button>

                   <button
                    class="ui button toggle"
                    :class="[softwareSelection == 'lineniq' ? 'isactive_lineniq' : '']"
                    v-if="availableProduct.slug == 'lineniq' && availableProduct.status == 1"
                    @click="SwitchProduct(availableProduct.slug,availableProduct.id)" id="swicth_dashboard_btn_lineniq"
                    
                  >{{availableProduct.name}}
                  
                  </button>
                    <button
                    class="ui button toggle"
                    :class="[softwareSelection == 'equipmate' ? 'isactive_equipmate' : '']"
                    v-if="availableProduct.slug == 'equipmate' && availableProduct.status == 1"
                    @click="SwitchProduct(availableProduct.slug,availableProduct.id)" id="swicth_dashboard_btn_equipmate"
                    
                  >{{availableProduct.name}}
                  
                  </button>

              </div>

          </div>

          <div class="col-md-2 col-6 text-right">

            <ul class="navbar-nav navbar_list" style="order:3; display:flex; flex-direction:row; float: right;">
              <!-- Sync RFID -->
              <li v-if="role == 0 || role == 1" class="nav-item mr-2 mt-2">
                <button type="button" class="btn btn-sm sync-rfid-btn" @click="showSyncRfidPopup = true">
                  Sync RFID
                </button>
              </li>
              <!-- Settings -->
                <li v-if="role == 0 || role == 1" class="nav-item mr-2 mt-2">
                  <router-link to="/settings">
                    <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.35695 1.8728C9.60361 1.69547 9.95028 1.6128 10.2909 1.73747C11.0152 2.00279 11.6879 2.39191 12.2789 2.88747C12.5569 3.1208 12.6589 3.46147 12.6283 3.7628C12.5783 4.2648 12.6663 4.74947 12.9083 5.1668C13.1216 5.53813 13.4429 5.83147 13.8349 6.03813L13.9849 6.11147C14.2609 6.23613 14.5063 6.49547 14.5683 6.85347C14.6999 7.61224 14.6999 8.38803 14.5683 9.1468C14.5129 9.46947 14.3083 9.71147 14.0663 9.84747L13.9849 9.88947C13.5249 10.0961 13.1489 10.4161 12.9076 10.8335C12.6663 11.2515 12.5783 11.7355 12.6283 12.2375C12.6583 12.5388 12.5569 12.8801 12.2789 13.1128C11.6879 13.6084 11.0152 13.9975 10.2909 14.2628C10.1361 14.3182 9.97015 14.3348 9.80745 14.3112C9.64475 14.2876 9.49031 14.2245 9.35761 14.1275C8.94695 13.8335 8.48228 13.6668 8.00028 13.6668C7.51828 13.6668 7.05361 13.8328 6.64361 14.1275C6.51084 14.2246 6.35628 14.2878 6.19345 14.3114C6.03063 14.335 5.8645 14.3183 5.70961 14.2628C4.98535 13.9975 4.31268 13.6084 3.72161 13.1128C3.59642 13.0064 3.49915 12.8711 3.43826 12.7185C3.37737 12.5659 3.35472 12.4008 3.37228 12.2375C3.42228 11.7355 3.33361 11.2508 3.09228 10.8335C2.87248 10.4609 2.55103 10.1586 2.16561 9.96213L2.01561 9.8888C1.86518 9.82217 1.73335 9.7197 1.63166 9.59035C1.52998 9.461 1.46152 9.30872 1.43228 9.1468C1.30057 8.38803 1.30057 7.61224 1.43228 6.85347C1.48761 6.5308 1.69228 6.2888 1.93428 6.1528L2.01561 6.11147C2.47561 5.90413 2.85161 5.5848 3.09294 5.1668C3.33361 4.74947 3.42228 4.2648 3.37228 3.7628C3.35472 3.59947 3.37737 3.43433 3.43826 3.28176C3.49915 3.12919 3.59642 2.99383 3.72161 2.88747C4.31268 2.39191 4.98535 2.00279 5.70961 1.73747C5.86442 1.68216 6.03041 1.66557 6.19309 1.68916C6.35578 1.71275 6.51023 1.7758 6.64294 1.8728C7.05294 2.16747 7.51761 2.33347 8.00028 2.33347C8.48295 2.33347 8.94695 2.16747 9.35695 1.8728ZM9.99495 3.05213C9.41761 3.43213 8.73695 3.6668 8.00028 3.6668C7.26361 3.6668 6.58295 3.43147 6.00561 3.05213C5.5415 3.23947 5.10611 3.49128 4.71228 3.80013C4.75228 4.4888 4.61561 5.19547 4.24761 5.83347C3.87894 6.4708 3.33561 6.94213 2.71894 7.25213C2.64947 7.74793 2.64947 8.251 2.71894 8.7468C3.33561 9.0568 3.87894 9.52813 4.24761 10.1668C4.61561 10.8035 4.75228 11.5101 4.71228 12.1988C5.10607 12.5079 5.54146 12.7599 6.00561 12.9475C6.58295 12.5675 7.26361 12.3328 8.00028 12.3328C8.73695 12.3328 9.41761 12.5681 9.99495 12.9475C10.459 12.7601 10.8944 12.5083 11.2883 12.1995C11.2483 11.5101 11.3849 10.8035 11.7529 10.1661C12.1209 9.52813 12.6649 9.0568 13.2816 8.74613C13.3511 8.25078 13.3511 7.74816 13.2816 7.2528C12.6649 6.94213 12.1216 6.4708 11.7529 5.8328C11.3849 5.19547 11.2483 4.4888 11.2883 3.79947C10.8944 3.49061 10.4591 3.2388 9.99495 3.05147V3.05213ZM8.00028 5.33347C8.70752 5.33347 9.3858 5.61442 9.8859 6.11452C10.386 6.61461 10.6669 7.29289 10.6669 8.00013C10.6669 8.70738 10.386 9.38566 9.8859 9.88575C9.3858 10.3858 8.70752 10.6668 8.00028 10.6668C7.29303 10.6668 6.61476 10.3858 6.11466 9.88575C5.61456 9.38566 5.33361 8.70738 5.33361 8.00013C5.33361 7.29289 5.61456 6.61461 6.11466 6.11452C6.61476 5.61442 7.29303 5.33347 8.00028 5.33347ZM8.00028 6.6668C7.64666 6.6668 7.30752 6.80728 7.05747 7.05733C6.80742 7.30737 6.66695 7.64651 6.66695 8.00013C6.66695 8.35376 6.80742 8.69289 7.05747 8.94294C7.30752 9.19299 7.64666 9.33347 8.00028 9.33347C8.3539 9.33347 8.69304 9.19299 8.94309 8.94294C9.19314 8.69289 9.33361 8.35376 9.33361 8.00013C9.33361 7.64651 9.19314 7.30737 8.94309 7.05733C8.69304 6.80728 8.3539 6.6668 8.00028 6.6668Z" fill="#9C9BAE"/>
                    </svg>
                  </router-link>
                </li>
                <!-- Notification Bell -->
                <!-- <li v-if="role == 0 || role == 1 || role == 4" class="nav-item mr-2 mt-2">
                  <router-link to="/notifications">
                    <span class="mt-2 " >
                      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.6167 9.0575V9.07821L12.6313 9.09285L13.7693 10.2309L13.7694 10.2309C13.8267 10.2881 13.8722 10.356 13.9032 10.4308C13.9342 10.5056 13.9501 10.5858 13.95 10.6668V10.6668V12.0002C13.95 12.1637 13.885 12.3206 13.7694 12.4362C13.6537 12.5519 13.4969 12.6168 13.3333 12.6168H2.66667C2.50312 12.6168 2.34627 12.5519 2.23062 12.4362C2.11497 12.3206 2.05 12.1637 2.05 12.0002L2.05 10.6668L2.05 10.6668C2.04988 10.5858 2.06578 10.5056 2.09678 10.4308C2.12778 10.356 2.17327 10.2881 2.23063 10.2309L2.23069 10.2309L3.36869 9.09285L3.38333 9.07821V9.0575V6.66683C3.38333 4.54539 4.82426 2.75858 6.77662 2.22036L6.80062 2.21375L6.80981 2.19061C6.99783 1.71701 7.45718 1.3835 8 1.3835C8.54282 1.3835 9.00217 1.71701 9.1902 2.19061L9.19938 2.21376L9.22339 2.22037C11.1757 2.75792 12.6167 4.54538 12.6167 6.66683V9.0575ZM12.6667 11.3835H12.7167V11.3335V10.9428V10.9221L12.702 10.9075L11.564 9.76947L11.5639 9.76938C11.4481 9.65417 11.3833 9.49762 11.3833 9.3335V6.66683C11.3833 4.80122 9.86561 3.2835 8 3.2835C6.13439 3.2835 4.61667 4.80122 4.61667 6.66683V9.3335V9.33357C4.61678 9.41454 4.60089 9.49473 4.56989 9.56953C4.53889 9.64433 4.4934 9.71226 4.43604 9.76941L4.43598 9.76947L3.29798 10.9075L3.28333 10.9221V10.9428V11.3335V11.3835H3.33333H12.6667ZM14 12.0002V10.6668L2.19533 10.1955C2.13331 10.2573 2.08411 10.3308 2.05059 10.4117C2.01707 10.4925 1.99987 10.5793 2 10.6668V12.0002C2 12.177 2.07024 12.3465 2.19526 12.4716C2.32029 12.5966 2.48986 12.6668 2.66667 12.6668H13.3333C13.5101 12.6668 13.6797 12.5966 13.8047 12.4716C13.9298 12.3465 14 12.177 14 12.0002ZM8.00006 14.6168H7.99994C7.59746 14.6173 7.20483 14.4924 6.87661 14.2595C6.56768 14.0402 6.33026 13.7355 6.19306 13.3835H9.80694C9.66974 13.7355 9.43232 14.0402 9.12339 14.2595C8.79517 14.4924 8.40254 14.6173 8.00006 14.6168Z" fill="#9A9AB0" stroke="white" stroke-width="0.1"/>
                      </svg>
                    </span>
                  </router-link>
                </li> -->

                <!-- Notification Bell -->
                <li v-if="role == 0 || role == 1 || role == 4" class="nav-item mr-2 mt-2">
                  <div class="dropdown">
                    <button type="button" data-toggle="dropdown">
                      <span class="mt-2 notification-count-wrapper" @click="notified">
                      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.6167 9.0575V9.07821L12.6313 9.09285L13.7693 10.2309L13.7694 10.2309C13.8267 10.2881 13.8722 10.356 13.9032 10.4308C13.9342 10.5056 13.9501 10.5858 13.95 10.6668V10.6668V12.0002C13.95 12.1637 13.885 12.3206 13.7694 12.4362C13.6537 12.5519 13.4969 12.6168 13.3333 12.6168H2.66667C2.50312 12.6168 2.34627 12.5519 2.23062 12.4362C2.11497 12.3206 2.05 12.1637 2.05 12.0002L2.05 10.6668L2.05 10.6668C2.04988 10.5858 2.06578 10.5056 2.09678 10.4308C2.12778 10.356 2.17327 10.2881 2.23063 10.2309L2.23069 10.2309L3.36869 9.09285L3.38333 9.07821V9.0575V6.66683C3.38333 4.54539 4.82426 2.75858 6.77662 2.22036L6.80062 2.21375L6.80981 2.19061C6.99783 1.71701 7.45718 1.3835 8 1.3835C8.54282 1.3835 9.00217 1.71701 9.1902 2.19061L9.19938 2.21376L9.22339 2.22037C11.1757 2.75792 12.6167 4.54538 12.6167 6.66683V9.0575ZM12.6667 11.3835H12.7167V11.3335V10.9428V10.9221L12.702 10.9075L11.564 9.76947L11.5639 9.76938C11.4481 9.65417 11.3833 9.49762 11.3833 9.3335V6.66683C11.3833 4.80122 9.86561 3.2835 8 3.2835C6.13439 3.2835 4.61667 4.80122 4.61667 6.66683V9.3335V9.33357C4.61678 9.41454 4.60089 9.49473 4.56989 9.56953C4.53889 9.64433 4.4934 9.71226 4.43604 9.76941L4.43598 9.76947L3.29798 10.9075L3.28333 10.9221V10.9428V11.3335V11.3835H3.33333H12.6667ZM14 12.0002V10.6668L2.19533 10.1955C2.13331 10.2573 2.08411 10.3308 2.05059 10.4117C2.01707 10.4925 1.99987 10.5793 2 10.6668V12.0002C2 12.177 2.07024 12.3465 2.19526 12.4716C2.32029 12.5966 2.48986 12.6668 2.66667 12.6668H13.3333C13.5101 12.6668 13.6797 12.5966 13.8047 12.4716C13.9298 12.3465 14 12.177 14 12.0002ZM8.00006 14.6168H7.99994C7.59746 14.6173 7.20483 14.4924 6.87661 14.2595C6.56768 14.0402 6.33026 13.7355 6.19306 13.3835H9.80694C9.66974 13.7355 9.43232 14.0402 9.12339 14.2595C8.79517 14.4924 8.40254 14.6173 8.00006 14.6168Z" fill="#9A9AB0" stroke="white" stroke-width="0.1"/>
                      </svg>
                      <!-- {{$store.state.tasks.taskCount}} -->
                      <span class="notification-count" > {{$store.state.support.ticketCount+$store.state.tasks.taskCount}}</span>
                    </span>
                    </button>
                  
                    <div class="dropdown-menu" style="position: absolute; border-radius: 8px; margin: 2rem 0rem 0rem -16.5rem !important; padding:0; min-width:440px;">
                      <div class="notification-dropdown">
                          <div class="notification-head ">
                        
                            <h6>Notification <span class="task-count ">{{$store.state.support.ticketCount+$store.state.tasks.taskCount}}</span> </h6>
                          </div>

                          <div class="notification-body">
                            <div>
                              <b-card no-body class="notification-body-wrapper">
                                <b-tabs pills card class="notification-body-tabs">

                                  <!-- tab 1 -->
                                
                                  <b-tab active class="notification-body-tab">
                                    <template #title>
                                      Support <span class="tickets_count ">{{$store.state.support.ticketCount}}</span> 
                                    </template>

                                    <!-- first start-->
                                    <b-card-text v-if="$store.state.support.unreadTickets.length > 0">
                                        <div id="ticket-list">
                                        
                                          <div v-for="ticket in $store.state.support.unreadTickets" :key="ticket.id" class="notification-msg-wrapper d-flex justify-content-center align-items-center mt-0">
                                            <div class="col-8 pl-4 pb-0">
                                              <div class="notification-msg">   
                                                <div class="notification-user-msg">
                                                 <h6 class="notification-user-name mb-0">
                                                  <a @click="viewTicket(ticket.st_id ,ticket.organization_id)" href="javascript:void(0);">{{ ticket.title }}</a>
                                                  </h6>
                                                  
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-4 pt-3">
                                              <span style="font-size:12px;">{{ ticket.created_at | formatDateTime}}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </b-card-text>
                                    </b-tab>
                                  
                                  <!-- tab 2 -->
                                  <b-tab class="notification-body-tab">
                                  <template #title>
                                    Tasks <span class="task-count">{{ $store.state.tasks.taskCount }}</span> 
                                  </template>

                                  <b-card-text v-if="$store.state.tasks.unnotifiedTasks.length > 0">
                                    <div id="task-list">
                                      <div v-for="task in $store.state.tasks.unnotifiedTasks" :key="task.id" class="notification-msg-wrapper d-flex justify-content-center align-items-center mt-0">
                                        <div class="col-8 pl-4 pb-0">
                                          <div class="notification-msg">   
                                            <div class="notification-user-msg">
                                              <h6 class="notification-user-name mb-0">
                                                <a @click="quickView" :data-id="task.id" href="javascript:void(0);">{{ task.title }}</a>
                                              </h6>
                                              <!-- <p class="notification-user-detail">{{ task.description }}</p> -->
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-4 pt-3">
                                          <span style="font-size:12px;">{{ task.created_at  | formatDateTime}}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </b-card-text>
                                </b-tab>
                                </b-tabs>
                              </b-card>
                            </div>
                          </div>
                         
                      </div>
                    </div>
                  </div>
                </li>
                

                <!-- Profile Menu -->
                <li class="nav-item mr-2">
                  <div class="dropdown">
                    <button type="button" data-toggle="dropdown">
                      <div class="media">
                        <!-- <img src="..." class="mr-3" alt="..."> -->
                        <svg width="40" height="42" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink">
                          <rect y="0.812012" width="40" height="41.0552" rx="20" fill="#C4C4C4" />
                          <rect y="0.812012" width="40" height="41.0552" rx="20" fill="url(#pattern0)" />
                          <defs>
                            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                              <use xlink:href="#image0_325_4933" transform="translate(0 -0.108936) scale(0.00260417)" />
                            </pattern>
                            <image id="image0_325_4933" width="384" height="480"
                              xlink:href="data:image/jpeg;base64,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" />
                          </defs>
                        </svg>
                        <div class="media-body text-left font-Mulish pl-1" style="line-height: 31px;font-size: 13px;">
                          <!-- <div > -->
                            <a class="profile-dropdown mt-1" id="username_hide">
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.00014 8.00014C5.88331 8.00037 5.77009 7.95968 5.68014 7.88514L2.68014 5.38514C2.57803 5.30027 2.51382 5.17831 2.50163 5.0461C2.48944 4.91389 2.53027 4.78225 2.61514 4.68014C2.70001 4.57803 2.82196 4.51382 2.95418 4.50163C3.08639 4.48944 3.21803 4.53027 3.32014 4.61514L6.00014 6.85514L8.68014 4.69514C8.73128 4.65361 8.79013 4.62259 8.8533 4.60387C8.91647 4.58516 8.98271 4.57911 9.04823 4.58608C9.11374 4.59305 9.17723 4.6129 9.23505 4.64449C9.29287 4.67607 9.34388 4.71877 9.38514 4.77014C9.43093 4.82155 9.46561 4.88186 9.487 4.9473C9.5084 5.01274 9.51605 5.08189 9.50948 5.15042C9.50291 5.21895 9.48226 5.28539 9.44881 5.34556C9.41537 5.40574 9.36986 5.45837 9.31514 5.50014L6.31514 7.91514C6.2226 7.9779 6.11169 8.00782 6.00014 8.00014Z" fill="#151612"/>
                              </svg>
                            </a>
                          <!-- </div> -->
                          <div  id="username_display">
                            <h6 class="my-0 font-weight-bold py-0 username_display_h" style="color: #48a6a6 !important;">
                              {{ fname }} {{ lname }} {{getUser}}
                            </h6>
                            <!-- <a class="my-0 font-weight-bold py-0"> -->
                              
                            <!-- </a> -->
                            <small v-if="role == 0" class="py-0 text-muted">Super Admin</small>
                            <small v-else-if="role == 1" class="py-0 text-muted">Admin</small>
                            <small v-else-if="role == 2" class="py-0 text-muted">CRM</small>
                            <small v-else-if="role == 3" class="py-0 text-muted">Editor</small>
                            <small v-else-if="role == 4" class="py-0 text-muted">Support</small>
                            <small v-else-if="role == 5" class="py-0 text-muted">Data Entry</small>
                            <small v-else-if="role == 6" class="py-0 text-muted">Digital Marketing</small>
                            <small v-else-if="role == 7" class="py-0 text-muted">ADH</small>
                            <small v-else-if="role == 8" class="py-0 text-muted">Development Lead</small>
                            <small v-else-if="role == 9" class="py-0 text-muted">Developer</small>
                            <small v-else-if="role == 10" class="py-0 text-muted">CSM</small>
                            <small v-else-if="role == 11" class="py-0 text-muted">ADH Helper</small>
                            <small v-else-if="role == 12" class="py-0 text-muted">QA</small>
                            <small v-else-if="role == 13" class="py-0 text-muted">Designer</small>
                          </div>
                        </div>
                      </div>
                    </button>
                  
                    <div class="dropdown-menu" style="position: absolute; border-radius: 8px; margin: 0.025rem 0rem 0rem -5.5rem !important;">
                      <a class="profile-dropdown-items mt-1" @click="editProfile">
                        <i class="fas fa-user mr-2"></i>Edit Profile
                      </a>
                      <a class="profile-dropdown-items" @click="passwordReset">
                        <i class="fas fa-lock mr-2"></i>Change Password
                      </a>
                      <hr class="mt-2 mb-0" />
                      <a class="logout" @click="logout">
                        <i class="fas fa-sign-out-alt mr-2 mb-1"></i>Logout
                      </a>
                    </div>
                  </div>
                </li>
            </ul>
          </div>
        </div> 
    </nav>
    <!-- notifications message -->
    <message />

    <!-- main wrapper -->
    <div class="content-wrapper">
      <div class="container-fluid">
        <div class="row font">
          <div class="col-12 ">
            <router-view></router-view>
          </div>
        </div>
      </div>

      <foooter></foooter>
    </div>

    <chat v-if="chatOpenned" />

    <!--  <div v-else class="chat text-secondary hide">
      <h4 class="header" @click="chatOpenned = true">
        <font-awesome-icon icon="globe" />
        chat with authors
      </h4>
    </div> -->

    <!-- Sync RFID type selection popup -->
    <div v-if="showSyncRfidPopup" class="sync-rfid-overlay" @click.self="showSyncRfidPopup = false">
      <div class="sync-rfid-popup">
        <div class="sync-rfid-popup-header">
          <h6 class="sync-rfid-popup-title">Select Customer Type</h6>
          <button type="button" class="sync-rfid-popup-close" aria-label="Close" @click="showSyncRfidPopup = false">&times;</button>
        </div>
        <div class="sync-rfid-popup-body">
          <button type="button" class="btn sync-rfid-option-btn" @click="syncRfid('f&b')">F&B</button>
          <button type="button" class="btn sync-rfid-option-btn" @click="syncRfid('uniforms')">Uniforms</button>
        </div>
      </div>
    </div>

    <!-- form modal -->
    <modal></modal>
  </div>
</template>
<script>
  import Navbar from './partials/navbar';
  import Sidebar from './partials/sidebar';
  import Foooter from './partials/footer';
  import NavbarHeading from './partials/navbar_heading';
  import Modal from './partials/notifications/modal';
  import Message from './partials/notifications/message';
  import Chat from '@/components/chat';
  import ResetPasswordForm from "./partials/profile/reset_password_form.vue";
  import EditProfileForm from "./partials/profile/edit-profile.vue";
  import axios from 'axios';
  import quickView from "@/components/common/development/task/quickView.vue";


  export default {
    components: {
      Navbar, Sidebar, Foooter, Modal, Message, Chat , NavbarHeading, ResetPasswordForm,EditProfileForm, quickView
    },


    data: function () {
      return {
        chatOpenned: false,
        role: "",
        fname: "",
        lname: "",
        id: "",
        product: 1,
        softwareSelection:'',
        softwareSelection1: true,
        notification: true,
        taskHtml:'',
        userAvaliableProducts:{},
        userAssignedProduct :localStorage.getItem("user_product"),
        selectTab:'',
        filters:{},
        sortingBy: {},
        showSyncRfidPopup: false,
      }
      
    },
    created: function () {

        this.product = localStorage.getItem('product');
     
      if(this.product == 1){
        this.softwareSelection = 'linentech';
        localStorage.setItem('product_name','Linentech');

      }else if(this.product == 2){
        this.softwareSelection = 'staffer';
        localStorage.setItem('product_name','theStaffer');

      }else if(this.product == 3){
        this.softwareSelection = 'equipmate';
        localStorage.setItem('product_name','Equipmate');

      }else if(this.product == 4){
        this.softwareSelection =  'lineniq';
        localStorage.setItem('product_name','LinenIq');

      }

        window.$user = this.$auth.user();
        this.$gate.setUser(window.$user);
        this.role = localStorage.getItem("role");
        this.fname = localStorage.getItem("f_name");
        this.lname = localStorage.getItem("l_name");
        this.id = localStorage.getItem("admin_id");
        this.userAvaliableProducts = this.availableProducts.filter(product =>
         this.userAssignedProduct.includes(product.id)
        );
      },
    computed: {
      availableProducts: function () {
        return this.$store.getters['persist/availableProducts'];
      },
      getUser: function(){  
        this.fname = localStorage.getItem("f_name");
        this.lname = localStorage.getItem("l_name");
      },
      current_page() {
      return this.$route.query.page ? parseInt(this.$route.query.page) : 1;
    }
     

    },
    watch:{
    },
    mounted: function(){
      this.notified();
     
      // if(this.product == 0){
      //   $('#swicth_dashboard_btn_linentech').addClass('isactive_linentech');
      // $('#swicth_dashboard_btn_staffer').removeClass('isactive_thestaffer');
      // }
      // else{
      //   $('#swicth_dashboard_btn_linentech').removeClass('isactive_linentech');
      // $('#swicth_dashboard_btn_staffer').addClass('isactive_thestaffer');
      // }
    },
    methods: {
      viewTicket(id,org_id)
          {
          this.$store.dispatch("support/viewticket", { id, org_id });
          const url = '/support/ticket/' + id + '/' + org_id;
          this.$router.push(url);

          },
        quickView(event) {
          this.$store.dispatch("tasks/view", [event.target.dataset.id]).then((response) => {
            this.$store.dispatch("modal/taskQuickView", {
              title: "Task Details",
              formData: {
                task: response,
                developers: this.developers,
              },
              component: quickView,
            });
          });

        },
        notified()
        {
          this.$store.dispatch('tasks/setUnnotifiedTaskCount');
          this.$store.dispatch('support/setUnreadTicketsCount');
        },
        async syncRfid(type) {
          this.showSyncRfidPopup = false
          let loader = null
          try {
            loader = this.$loading.show({ loader: 'dots' })
          } catch {
            // ignore if loader plugin is not available for some reason
          }

          try {
            const res = await axios.post('/admin/sync-rfid', { _method: 'POST', type: type })
            const message =
              res && res.data && res.data.message ? res.data.message : 'RFID synced successfully'
            this.$toast.success(message)
          } catch (error) {
            const msg =
              error && error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error && error.message
                  ? error.message
                  : 'Failed to sync RFID. (Endpoint: /admin/sync-rfid)'
            this.$toast.error(msg)
          } finally {
            if (loader) loader.hide()
          }
        },
        SwitchProduct(slug,id) {
          let loader = this.$loading.show({
            loader: "dots",
          });
          if(slug == 'linentech'){
            this.softwareSelection = slug;
            $('#swicth_dashboard_btn_staffer').removeClass('isactive_thestaffer');
            $('#swicth_dashboard_btn_equipmate').removeClass('isactive_equipmate');
            $('#swicth_dashboard_btn_lineniq').removeClass('isactive_lineniq');
            $('#swicth_dashboard_btn_linentech').addClass('isactive_linentech');

            this.product =id;
            this.$store.dispatch("persist/setSelectedProduct", this.product);
            localStorage.setItem('product', id);
            localStorage.setItem('product_name','Linentech');
            this.getLeads();
            
          }
          else if(slug == 'staffer'){
            
            this.softwareSelection = slug;
            $('#swicth_dashboard_btn_linentech').removeClass('isactive_linentech');
            $('#swicth_dashboard_btn_equipmate').removeClass('isactive_equipmate');
            $('#swicth_dashboard_btn_lineniq').removeClass('isactive_lineniq');
            $('#swicth_dashboard_btn_staffer').addClass('isactive_thestaffer');
            this.product = id;
            this.$store.dispatch("persist/setSelectedProduct", this.product);
            localStorage.setItem('product',id);
            localStorage.setItem('product_name','theStaffer');
            this.getLeads();
          }
          else if(slug == 'equipmate'){
            this.softwareSelection = slug;
            $('#swicth_dashboard_btn_staffer').removeClass('isactive_thestaffer');
            $('#swicth_dashboard_btn_lineniq').removeClass('isactive_lineniq');
            $('#swicth_dashboard_btn_linentech').removeClass('isactive_linentech');
            $('#swicth_dashboard_btn_equipmate').addClass('isactive_equipmate');
            this.product = id;
            this.$store.dispatch("persist/setSelectedProduct", this.product);
            localStorage.setItem('product',id);
            localStorage.setItem('product_name','Equipmate');
            this.getLeads();
          }
          else if(slug == 'lineniq'){
            this.softwareSelection = slug;
            $('#swicth_dashboard_btn_staffer').removeClass('isactive_thestaffer');
            $('#swicth_dashboard_btn_lineniq').removeClass('isactive_lineniq');
            $('#swicth_dashboard_btn_linentech').removeClass('isactive_linentech');
            $('#swicth_dashboard_btn_lineniq').addClass('isactive_lineniq');
            this.product = id;
            this.$store.dispatch("persist/setSelectedProduct", this.product);
            localStorage.setItem('product',id);
            localStorage.setItem('product_name','LinenIq');
            this.getLeads();
          }
          
          setTimeout(() => {
            loader.hide();
          }, 2000);
        },
        // StafferProduct() {

        //   let loader = this.$loading.show({
        //     loader: "dots",
        //   });
          
        //   setTimeout(() => {
        //     loader.hide();
        //   }, 2000);
        // },
      getLeads(){
        var url = window.location.pathname.split('/').filter(Boolean).pop();
      if(url=='demo-leads')
      {
        this.selectTab = localStorage.getItem("tab");
              this.$store.dispatch("users/getAllDemoRequests", [this.current_page,"",this.selectTab]).then(() => {
                  loader.hide();
                  this.skeletonLoader = false;
                  this.$emit("skeletonLoader", this.skeletonLoader);
                });
      }
       else if(url == 'progress-report'){ 
        let product_id=localStorage.getItem('product');
       this.$store.dispatch("users/gettaskprogressBySearch",[this.$store.getters['users/get_team'],this.$store.getters['users/get_user'], this.$store.getters['users/startdate'],this.$store.getters['users/enddate'],this.$store.getters['users/search'],product_id]).then(() => {
      this.isLoader = false;
    });
      }
         else if(url == 'categories'){ 
        // let product_id=localStorage.getItem('product');
       
         this.$store.dispatch("categories/getAllCategories", [this.current_page]).then(() => {
                  loader.hide();
                  this.skeletonLoader = false;
                  this.$emit("skeletonLoader", this.skeletonLoader);
                });
      }
      else if(url == 'posts'){
         this.$store.dispatch("posts/getAllPosts", [this.current_page]).then(() => {
                  loader.hide();
                  this.skeletonLoader = false;
                  this.$emit("skeletonLoader", this.skeletonLoader);
                });
      }
       else if(url == 'new-post'){
      
            this.$store.dispatch("posts/getAllPosts", [this.current_page]).then(() => {
                  loader.hide();
                  this.skeletonLoader = false;
                  this.$emit("skeletonLoader", this.skeletonLoader);
                });
      }
        else if(url == 'unpublished'){
          let product_id=localStorage.getItem('product');
         this.$store.dispatch("posts/getUnpublishedPosts").then(() => {
                  loader.hide();
                  this.skeletonLoader = false;
                  this.$emit("skeletonLoader", this.skeletonLoader);
                });
      }
      else if(url == 'event'){
      this.$store.dispatch("events/getAllEvent", [1,'']).then(() => {
      loader.hide();
      this.skeletonLoader = false;
      this.$emit("skeletonLoader", this.skeletonLoader);
      });
     }
     else if(url == 'user-guide'){
      this.$store.dispatch("userGuide/getAllUserGuide", [1,'']).then(() => {
      loader.hide();
      this.skeletonLoader = false;
      this.$emit("skeletonLoader", this.skeletonLoader);
      });
     }
     else if(url == 'case-study'){
      this.$store.dispatch("caseStudy/getAllCaseStudy", [1,'']).then(() => {
      loader.hide();
      this.skeletonLoader = false;
      this.$emit("skeletonLoader", this.skeletonLoader);
      });
     }
     else if(url == 'brochure'){
      this.$store.dispatch("brochures/getAllbrochures", [1,'']).then(() => {
      loader.hide();
      this.skeletonLoader = false;
      this.$emit("skeletonLoader", this.skeletonLoader);
      });
     }
     else if(url == 'webinar'){
      this.$store.dispatch("webinar/getAllwebinars", [1,'']).then(() => {
      loader.hide();
      this.skeletonLoader = false;
      this.$emit("skeletonLoader", this.skeletonLoader);
      });
     }
      else{

            // let filtersData = [this.$store.getters['tasks/currentPage'], this.$store.getters['tasks/filters'], []]
            // this.filters.product_id = this.product;
              this.getRecords();
      }
      

      },
      getRecords(page = 1){
        // this.setSkeletonLoader(true);
          let filtersData = [this.$store.getters['tasks/currentPage'], this.$store.getters['tasks/filters'], []];
        this.$store.dispatch("tasks/getAll", filtersData).then(() => {
        });
            },                                                                                              
      logout() {
       
        localStorage.removeItem("tab");
        localStorage.removeItem("role");
        localStorage.removeItem("admin_id");
        localStorage.removeItem("f_name");
        localStorage.removeItem("l_name");
        localStorage.removeItem("show_filter");
        localStorage.removeItem("software_filter");
        localStorage.removeItem("demo_filter");
        localStorage.removeItem("direction");
        localStorage.removeItem("column");
        localStorage.removeItem('product');
        localStorage.removeItem('user_permissions');

        this.$auth.logout({
          makeRequest: true,
          data: {},
          success: function () { },
          error: function () { },
          redirect: "/login",
        });
      },
      passwordReset() {
        //  let pageNumber = this.page;
        this.$store.dispatch("modal/passwordReset", {
          action: "create",
          title: "Reset User Password",
          component: ResetPasswordForm,
        });
      },
      editProfile() {
        this.$store.dispatch("modal/editProfile", {
          action: "create",
          title: "Edit Profile",
          formData: {
            id: this.id,
            role: this.role,
          },
          component: EditProfileForm,
        });
      },
    },
  }
</script>

<style>
.multiselect__element .multiselect__option--highlight {
    background: #48a6a6 !important;
  }
  
  .multiselect__option.multiselect__option--highlight.multiselect__option--selected:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option--highlight:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option.multiselect__option--highlight.multiselect__option--selected{
      background: rgb(72, 166, 166) !important;
         /* color: #FFFFFF; */
  }
  .multiselect__placeholder {
      margin-bottom: 7px !important;
      padding-top: 0px !important;
  }
  .b-skeleton {
    background-color: #e7eef3 !important
  }
  .tooltip{
    border: 0px solid black !important;
    top: -24px !important;
  }
  .tooltip.bs-tooltip-top{
     top: 24px !important;
  }
  .tooltip .tooltip-inner {
    max-width: 200px !important;
    padding: 0.25rem 0.5rem !important;
    color: #000000de !important;
    text-align: center !important;
    background-color: #dbddde !important;
    border-radius: 0.25rem !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }
  .btn:focus{
    box-shadow: 0 0 0 0.2rem rgb(72 166 166 / 44%) !important;
  }

  .sync-rfid-btn{
    background: #48a6a6 !important;
    border-color: #48a6a6 !important;
    color: #fff !important;
    border-radius: 6px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    padding: 6px 10px !important;
    line-height: 1 !important;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
  }
  .sync-rfid-btn:hover{
    background: #3e9797 !important;
    border-color: #3e9797 !important;
    color: #fff !important;
  }

  /* Sync RFID type selection popup */
  .sync-rfid-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sync-rfid-popup {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    min-width: 280px;
  }
  .sync-rfid-popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .sync-rfid-popup-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #16181b;
  }
  .sync-rfid-popup-close {
    background: none;
    border: none;
    font-size: 24px;
    line-height: 1;
    color: #6c757d;
    cursor: pointer;
    padding: 0 4px;
  }
  .sync-rfid-popup-close:hover {
    color: #16181b;
  }
  .sync-rfid-popup-body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sync-rfid-option-btn {
    background: #48a6a6 !important;
    border-color: #48a6a6 !important;
    color: #fff !important;
    font-weight: 600;
    padding: 10px 16px;
    border-radius: 6px;
  }
  .sync-rfid-option-btn:hover {
    background: #3e9797 !important;
    border-color: #3e9797 !important;
    color: #fff !important;
  }

#ticket-list{
  display:flex;
  flex-direction:column;
}
.notification-count-wrapper{
  position: relative;
}
.notification-count{
  position: absolute;
    top: -30%;
    right: -29%;
    width: 18px;
    height: 18px;
    background: #DF5439;
    border-radius: 50%;
    font-size: 9px;
    font-weight: 600;
    color: #fff;
    border: 0.5px solid #fff;
    padding-top:1px;
}
.notification-dropdown .notification-head, .notification-dropdown .notification-foot{
  background: #EEF4F4;
}
.notification-dropdown .notification-head{
  border-radius: 10px 10px 0px 0px !important;
}
.notification-dropdown .notification-head h6, .notification-dropdown .notification-foot a{
  color: #48A6A6;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  padding: 20px;
  text-align: center;
  display: block;
} 
.card.notification-body-wrapper{
  border-radius: 0;
  border: 0;
}
.notification-body-tabs .card-header{
  background: transparent;
  border: 0;
}
.notification-body .nav-pills {
  display:flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
}
.notification-body .nav-pills .nav-item{
  width: 100%;  
}

.notification-body .nav-pills .nav-link.active, 
.notification-body .nav-pills .show > .notification-body .nav-link, 
.notification-body .nav-pills .nav-link, 
.notification-body .nav-pills > .nav-link{
  background: #48A6A6;
  color: #fff !important;
  height: 40px;
  padding: 8px;
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
}
.notification-body .nav-pills .nav-link:not(.active){
  background: transparent;
  color: #000 !important;
}
.notification-body .nav-pills .nav-link:not(.active) .task-count,
.notification-body .nav-pills .nav-link:not(.active) .tickets_count {
  color: #e2242d !important;
}

.notification-body-tab.card-body{
  padding: 0 0 35px 0;
  overflow: auto;
}
.notification-body-tab .card-text{
  padding: 15px 0 15px 0px;
  border-top: 1px solid rgba(72, 166, 166,0.5);
}
.notification-body-tab p{
  margin-bottom:0px;
}

.notification-body-tab .notification-msg{
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 0 20px;
  position: relative;
}
.notification-user-msg::before{
      content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    position: absolute;
    top: 3px;
    left: -6px;
}
.notification-user-msg::after{
      content: "";
    height: 50px;
    width:1px;
    background: #ccc;
    position: absolute;
    top: 5px;
    left: -1px;
}
.tabs.notification-body-tabs .tab-content{
  max-height: 350px;
  overflow:auto;
}
.notification-user-name a{
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0 20px 0 0;
  color: #48a6a6;
}
.notification-user-msg{
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: #707070;
}
.notification-time p{
  font-size: 10px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: right;
  color: #B4BCC3;
}

.notification-user-img{
  position: relative;
}
.notification-user-img .notification-dot{
  position : absolute;
  top: 0;
  right:0;
  width:12px;
  height:12px;
  border-radius:50%;
  background: #DF5439;
}
.notification-foot{
  border-top: 1px solid rgba(72, 166, 166,0.5);
  border-radius: 0 0 10px 10px;
}

.tabs.notification-body-tabs .tab-content::-webkit-scrollbar {
  width: 5px; 
  padding: 0 5px;
}

.tabs.notification-body-tabs .tab-content::-webkit-scrollbar-thumb {
  background-color: #C8CCCC; 
  border-radius: 4px; 
}

.tabs.notification-body-tabs .tab-content::-webkit-scrollbar-track {
  background-color: #EEF4F4;
}

</style>
<style scoped>
 
  .isactive_linentech{
    color: #e2242d;
    background: #48a6a6;
    border-radius: 26px;
    color: white;
    transition: all 500ms ease;
  }
  .isactive_thestaffer{
    color: #e2242d;
    background: #4bb87b;
    border-radius: 26px;
    color: white;
    transition: all 500ms ease;
  }
   .isactive_equipmate{
    color: #e2242d;
    background: #4bb87b;
    border-radius: 26px;
    color: white;
    transition: all 500ms ease;
  }
   .isactive_lineniq{
    color: #e2242d;
    background: #4bb87b;
    border-radius: 26px;
    color: white;
    transition: all 500ms ease;
  }
  
.swicth_dashboard_btn{
  /* border: 1px solid #e4ebf2; */
  border-radius: 26px;
  margin-right: 0%;
  display:block;
  width: max-content;
  float: right;
}

.ui.buttons.big.swicth_dashboard_btn > .button {
    padding: 6px 12px 6px 12px;
}
.staffer_active{
-ms-transform: rotate(180deg); 
  transform: rotate(180deg);
}
  #mainNav{
    z-index: 12;
  }
  
   #username_display{
    display: block !important;
    line-height: 1;
    margin-top: 6px;
    white-space: nowrap;
    }
    #username_hide{
      display: none !important;
    }
  
  .nav-cs-h {
    height: 80px;
    font-family: Mulish, 'sans-serif';
  }

  .font {
    font-family: Mulish, 'sans-serif';
  }
  .navbar_list{
    display:block !important;
        order: 3;
    display: flex !important;
    flex-direction: row;
    flex-wrap: nowrap !important;
    align-items: center;
    justify-content: flex-end;
    float: none !important;
  }
  .navbar_list > .nav-item{
    display: flex;
    align-items: center;
  }

  .username_display_h{
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .content-wrapper{
    padding: 110px 0 63px 9px !important;
  }
  #main_row{
    margin-top: 2px !important;
  }
  .btn>.fas.fa-ellipsis-v{
    color:#48a6a6 !important;
  }
   /* #mainNav .barResponive{
    display: none;
  } */
  /* .navbar_left{
    
  } */
  @media (min-width: 1280px) and (max-width:1366px){
    #username_display{
      font-size: 14px !important;
    }
    .username_display_h{
      font-size: 14px !important;
    }

  }
  .swicth_dashboard_btn-col{
    display: inline-flex;
    font-size: small;
  }
 @media (min-width: 320px) and (max-width:680px){
  .swicth_dashboard_btn, .swicth_dashboard_btn-col{
    display: none;
  }
  .container-fluid{
    padding-right: 0% !important;
    padding-left: 0% !important;
  }
  .main_span{
    font-size: 14px !important;
  }
  #mobile_toggle_btn{
    display: inline-block !important;
    padding: 0.25rem !important;
    /* margin-top: 9px !important; */
  }
  #tab_toggle_btn{
    display: none !important;
  }
  .nav-cs-h {
    height: 67px;
  }
  #main_row {
    margin-top: -4px !important;
    margin-left: 0rem !important;
    display: flex;
    flex-direction: column;
    
  }
  #main_row_navbar{
    margin-right: 0%;
    margin-bottom: 9px;
  }
  #cpanel_div{
    margin-top: -19%;
    margin-left: 39px;
  }
  #navbar_settings, .navbar_list{
    display: block !important;
  }
  .navbar_list{
    /* display:block !important; */
        order: 3;
    display: flex !important;
    flex-direction: row;
  }
  .navbar-expand-lg  #navbar_responsive{
      display: block !important;
    }
    /* .content-wrapper{
      padding: 58px 0 90px 0px !important;
    } */
  .content-wrapper{
    padding: 58px 0 39px 0px !important;
  }
    
    #username_display{
    display: none !important;
    }
    #username_hide{
      display: block !important;
    }
    #mainNav .navbar-collapse{
      max-height: 84vh !important;
    }
    #mainNav {
      height: 59px !important;
    }
    .nav-link-collapse svg{
      width: 19 !important;
      height: 20 !important;
    }
    #navbarResponsive{
      width: 175% !important
    }
    #mainNav.border-bottom{
      border-bottom: 1px solid  #00000000 !important;
    }
    /* .setting_body_center{
      padding:0.4rem 1.5rem !important
    } */
}
@media (min-width:991px){
   #tab_toggle_btn{
    display: none !important;
  }
}

@media (max-width:992px) and (min-width:700px){
  #mainNav .navbar-collapse{
    width: 200px !important;
    background: #fff;
    border-right: 1px solid #dee2e6 !important;
    position: absolute;
    top: 170%;
    left:-5%;
    max-height: 80svh;
    height: 100vh !important;
    padding-left:10px;
  }
  .mr-menu .reponsiveSidebar{
    height: 100vh;
  }
  .mr-menu{
    display:flex;
    justify-content:center;
    align-items:center;
    /* flex-direction:column; */
    position: absolute;
    z-index: 1;
    top:25%;
  }

  .mr-menu .navbar-brand{
    position: relative;
  }
  .mr-menu #cpanel_div{
    /* position: absolute;
    top: -50%;
    right:-10%; */
    
  }
  .mr-menu .navbar-toggler.navbar-toggler-right{
    font-size: 12px;
  }

  .menu-icon-link-wrapper{
    display: flex;
    align-items: center;
  }
}

@media (max-width:700px) and (min-width:320px){
  #main_row{
    flex-direction: row;
    flex-wrap: nowrap;
  }
  #mainNav .navbar-collapse{
    width: 220px !important;
    background: #fff;
    border-right: 1px solid #dee2e6 !important;
    position: absolute;
    top: 88%;
    left:-5%;
    max-height: 100vh !important;
    padding-left:10px;
  }
  .mr-menu .navbar-toggler.navbar-toggler-right{
    font-size: 12px;
  }
  #mobile_toggle_btn{
    display: none !important;
  }
  #tab_toggle_btn{
    display: flex !important;
    align-items: center;
    margin-right:10px;
  }
  .menu-icon-link-wrapper{
    display: flex;
    align-items: center;
  }
  .mr-menu #cpanel_div{
    /* position: absolute;
    top: 65%;
    right:-30%;
    transform: translate(-90%,25%); */
    margin: 0;
  }
  
}
</style>

